module.exports = require("lodash.isequal");